import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import OvChartPanelContainer from "./OvChartPanelContainer";
import { blue, orange, green } from "material-ui/colors";
import { dollarValue } from "./helpers/presentation";
import dimensions from "react-dimensions";
import Menu, { MenuItem } from "material-ui/Menu";

import {
  XYPlot,
  XAxis,
  YAxis,
  HorizontalGridLines,
  VerticalGridLines,
  HorizontalBarSeries,
  DiscreteColorLegend,
  Crosshair
} from "react-vis";
import { setQueryToEntity } from "./helpers/overviewUrl";

import { formatAccountsCrosshairTitle } from "./helpers/charts";

const styles = theme => ({
  root: {
    padding: 10,
    marginBottom: 20
  },
  dimButton: {
    color: theme.palette.action.disabled
  },
  xaxis: {
    height: 60,
    borderWidth: 1,
    borderColor: "red",
    borderStyle: "solid"
  },
  seriesLegend: {
    position: "absolute",
    top: 16,
    right: 110
  }
});

class OvAccountsCostChart extends Component {
  constructor(props) {
    super(props);

    this.onLegendButtonClick = this.onLegendButtonClick.bind(this);
    this.onBarClick = this.onBarClick.bind(this);
    this.handleRequestMenuClose = this.handleRequestMenuClose.bind(this);
    this.handleNavTimeChart = this.handleNavTimeChart.bind(this);
    this.handleNavAccount = this.handleNavAccount.bind(this);
    this.handleValueMouseOver = this.handleValueMouseOver.bind(this);
    this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
    this.formatCrosshairItems = this.formatCrosshairItems.bind(this);

    this.state = {
      crosshairValues: [],
      stack: true,
      series: this.generateSeries(props.data),
      menuAnchor: null,
      menuOpen: false,
      menuAccount: {}
    };
  }

  generateSeries(data) {
    const template = [
      {
        disabled: false,
        field: "instance_cost",
        title: "Instance cost",
        color: blue[500],
        data: []
      },
      {
        disabled: false,
        field: "license_cost",
        title: "License cost",
        color: orange[500],
        data: []
      },
      {
        disabled: false,
        field: "storage_cost",
        title: "Storage cost",
        color: green[500],
        data: []
      }
    ];
    data.forEach(el => {
      template[0].data.push({
        y: el.name,
        x: el.instance_cost
      });
      template[1].data.push({
        y: el.name,
        x: el.license_cost
      });
      template[2].data.push({
        y: el.name,
        x: el.storage_cost
      });
    });

    return template;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      series: this.generateSeries(nextProps.data)
    });
  }

  handleValueMouseOver(datapoint, event) {
    const { series } = this.state;
    const index = series[0].data.findIndex(el => el.y === datapoint.y);
    this.setState({
      crosshairValues: series.map(s => s.data[index])
    });
  }

  mouseLeaveHandler() {
    this.setState({ crosshairValues: [] });
  }

  formatCrosshairItems(values) {
    const { series } = this.state;
    return values.map((v, i) => {
      return {
        title: series[i].title,
        value: dollarValue(v.x)
      };
    });
  }

  onLegendButtonClick(item, i) {
    const { series } = this.state;
    series[i].disabled = !series[i].disabled;
    this.setState({ series });
  }

  onBarClick(datapoint, event) {
    this.setState({
      menuOpen: true,
      menuAnchor: event.event.currentTarget,
      menuAccount: datapoint.y.split("|")[0]
    });
  }

  handleRequestMenuClose() {
    this.setState({ menuOpen: false });
  }

  handleNavTimeChart() {
    this.setState({ menuOpen: false });
    const { filterState, history } = this.props;
    history.push(
      setQueryToEntity(filterState, "time", {
        key: "account",
        value: { id: this.state.menuAccount }
      })
    );
  }

  handleNavAccount() {
    this.setState({ menuOpen: false });
    const { history } = this.props;
    history.push(`/accounts/${this.state.menuAccount}/settings`);
  }

  renderSeries() {
    const result = [];
    this.state.series.forEach((s, i) => {
      if (!s.disabled) {
        result.push(
          <HorizontalBarSeries
            onValueMouseOver={this.handleValueMouseOver}
            color={s.color}
            key={i}
            data={this.state.series[i].data}
            onValueClick={this.onBarClick}
          />
        );
      }
    });
    return result;
  }

  plotHeight() {
    const n = this.state.series && this.state.series[0].data.length;
    if (n < 3) {
      return 150;
    }
    return n * 30 + 50;
  }

  renderPlot() {
    const { containerWidth, classes } = this.props;
    const plotWidth = containerWidth - 60;

    return (
      <XYPlot
        onMouseLeave={this.mouseLeaveHandler}
        margin={{ left: 200, bottom: 50 }}
        className={classes.plot}
        width={plotWidth}
        height={this.plotHeight()}
        yType="ordinal"
        stackBy="x"
      >
        <XAxis tickFormat={v => `${dollarValue(v)}`} tickLabelAngle={-30} />
        <YAxis tickFormat={v => v.split("|")[1]} />
        <VerticalGridLines />
        <HorizontalGridLines />
        {this.renderSeries()}
        <Crosshair
          itemsFormat={this.formatCrosshairItems}
          titleFormat={formatAccountsCrosshairTitle}
          values={this.state.crosshairValues}
        />
      </XYPlot>
    );
  }

  render() {
    const { loading } = this.props;

    return (
      <div>
        <OvChartPanelContainer
          chartSubheader=""
          chartTitle="Costs"
          loading={loading}
          chart={this.renderPlot()}
          chartActions={
            <div>
              <DiscreteColorLegend
                onItemClick={this.onLegendButtonClick}
                orientation="horizontal"
                items={this.state.series}
              />
            </div>
          }
        />

        <Menu
          anchorEl={this.state.menuAnchor}
          open={this.state.menuOpen}
          onRequestClose={this.handleRequestMenuClose}
        >
          <MenuItem dense onClick={this.handleNavTimeChart}>
            See this account in time chart
          </MenuItem>
          <MenuItem dense onClick={this.handleNavAccount}>
            Go to account page
          </MenuItem>
          <MenuItem dense onClick={this.handleRequestMenuClose}>
            Close
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

OvAccountsCostChart.propTypes = {
  data: PropTypes.array.isRequired,
  filterState: PropTypes.object.isRequired,
  containerWidth: PropTypes.number.isRequired
};

export { OvAccountsCostChart };

export default withStyles(styles, { name: "OvAccountsCostChart" })(
  dimensions({ elementResize: true })(OvAccountsCostChart)
);



// WEBPACK FOOTER //
// ./src/OvAccountsCostChart.js